<template lang="pug">
  .generic-wrapper
    .container
      BackButton(name="StatisticsOverview")
      h1.title Auslastung
      .sub-headline Hier können Sie die Auslastung der Mietobjekte einsehen.
      
      .calendar-config.margin-top      
        b-field(group)
          b-field(label-position="on-border" label="Jahr")
            b-select(v-model="year")
              option(v-for="y in currentYear+10-rootYear") {{rootYear + y}}

      .card.margin-top
        .top
          .chart
            .y-axis
              .month(v-for="(month, monthIdx) in months" :key="month")
                template(v-for="(r, idx) in rentObjectData.filter(r => r.monthData[monthIdx])")
                    template(v-for="mda in [r.monthData[monthIdx]]")
                      .tick(
                          v-if="isTickVisible(r.rentObjectId) && (mda.daysInMonth*mda.rentObjectCount) !== 0"
                          :style="{bottom: `${(mda.nightCount / (mda.daysInMonth*mda.rentObjectCount)) * 100}%`,background: `linear-gradient(180deg, ${colors[idx]}, transparent)`}")
                        .percent {{r.rentObjectName.slice(0,1)}} {{((mda.nightCount / (mda.daysInMonth*mda.rentObjectCount)) * 100).toFixed(2)}}%
                      .tick(v-else-if="isTickVisible(r.rentObjectId)" :style="{bottom: `100%`, background: `linear-gradient(180deg, ${colors[idx]}, transparent)`}")
                        .percent 100%
                      //- .percent {{ mda.nightCount }} {{ mda.daysInMonth }} {{ mda.rentObjectCount }} {{ mda.blockedCount }}
            .x-axis
              .month(v-for="(month, index) in months" :key="index" @click="month = index" :class="{active: month === index}") {{month}}
          .legend
            .legend-item(
              v-for="(r, idx) in rentObjectData.filter(r => r.monthData[0])"
               :key="r.rentObjectId"
              @click="toggleTickVisibility(r.rentObjectId)"
              :class="{ 'legend-item-disabled': !isTickVisible(r.rentObjectId) }"
            )
              .color(:style="{background: colors[idx]}")
              .name {{r.rentObjectName}}
</template>

<script>
import { DateTime } from 'luxon';

export default {
  data() {
    return {
      rentObjectParentId: null,
      rootYear: new Date().getFullYear() - 10,
      currentYear: new Date().getFullYear(),
      year: new Date().getFullYear(),
      currentMonth: new Date().getMonth(),
      month: -1,
      rentObjectData: [],
      months: [
        "Jan",
        "Feb",
        "Mär",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
      ],
      colors: [
        "#FF0000",
        "#00A500",
        "#0000FF",
        "#000000",
        "#FF00FF",
        "#00FFFF",
        "#3366E6",
        "#999966",
        "#99FF99",
      ],
      dataPerRentObjectParent: [],
      visibleTicks: {},
    };
  },
  computed: {
    rentObjects() {
      return this.$store.state.rentObjects.all;
    },
    rentObjectParents() {
      const unique = [...new Set(this.rentObjects.filter(r => r.parentId).map(r => r.parentId))];
      return this.rentObjects.filter(r => unique.includes(r.id));
    },
  },
  watch: {
    async rentObjectParentId() {
      this.getAllData()
    },
    async year() {
      this.getAllData()
    },
    rentObjectData: {
      handler() {
        this.initializeVisibleTicks()
      },
      deep: true
    }
  },
  async mounted() {
    this.$store.dispatch("rentObjects/findAll");
    this.getAllData();
  },
  methods: {
    async getAllData() {
      const loadingComponent = this.$buefy.loading.open();
      this.rentObjectData = [];
      const ownerIds = [7, 8, 9, 10];
      const data = await Promise.all(ownerIds.map(async id => {
        const monthData = {};
        for (let i = 0; i < 12; i++) {
          const month = await this.$store.dispatch("owners/statistics", { id, year: this.year, month: i });
          monthData[i] = month;
        }
        return monthData;
      }));
      const dataPerRentObjectParent = this.rentObjectParents.map(rentObject => {
        return {
          id: rentObject.id,
          rentObject,
          dataPerMonth: []
        };
      });
      for (let i = 0; i < 12; i++) {
        const monthData = data.map(d => d[i]);
        const flatData = monthData.flat();
        for (let j = 0; j < dataPerRentObjectParent.length; j++) {
          const rentObjectsWithParentId = flatData.filter(r => r.rentObject.parentId === dataPerRentObjectParent[j].id && r.rentObject.rentObjectTypeId === 14);
          if (rentObjectsWithParentId.length === 0) {
            continue;
          }
          dataPerRentObjectParent[j].dataPerMonth.push(rentObjectsWithParentId);
        }
      }

      for (let i = 0; i < dataPerRentObjectParent.length; i++) {
        const rentObject = dataPerRentObjectParent[i].rentObject;
        const dataPerMonth = dataPerRentObjectParent[i].dataPerMonth;
        const monthData = [];
        for (let j = 0; j < dataPerMonth.length; j++) {
          const sumData = {
            blockedCount: 0,
            contractCount: 0,
            grossRevenue: 0,
            netRevenue: 0,
            nightCount: 0,
            totalCommission: 0,
            rentObjectCount: 0,
            test: '',
            daysInMonth: DateTime.fromObject({ year: this.year, month: j + 1 }).daysInMonth,
            monthName: new Date(this.year, j).toLocaleString('de-DE', { month: 'long' }),
          };
          if (!dataPerMonth[j]) {
            continue;
          }
          for (const rentObjectData of dataPerMonth[j]) {
            sumData.test += rentObjectData.rentObject.name + ', ',
              sumData.blockedCount += rentObjectData.blockedCount;
            sumData.contractCount += rentObjectData.contractCount;
            sumData.grossRevenue += rentObjectData.grossRevenue;
            sumData.netRevenue += rentObjectData.netRevenue;
            sumData.nightCount += rentObjectData.nightCount;
            sumData.totalCommission += rentObjectData.totalCommission;
            sumData.rentObjectCount += 1;
          }
          monthData.push(sumData);
        }
        const rentObjectData = {
          rentObjectName: rentObject.name,
          rentObjectId: rentObject.id,
          dataPerMonth,
          monthData,
        };
        this.rentObjectData.push(rentObjectData);
      }
      console.log(this.rentObjectData);
      loadingComponent.close();
    },
    initializeVisibleTicks() {
      // Initialize visibility for all rent objects when rentObjectData is updated
      this.visibleTicks = {};
      this.rentObjectData.forEach(r => {
        this.$set(this.visibleTicks, r.rentObjectId, true);
      });
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yy")
    },
    formatDateTime(d) {
      if (d instanceof Date) {
        const dt = DateTime.fromJSDate(d);
        return dt.setLocale('de')
          .toFormat("dd.LL.yyyy")
      }
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yyyy")
    },
    toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    },
    toggleTickVisibility(rentObjectId) {
      if (this.visibleTicks[rentObjectId] !== undefined) {
        this.$set(this.visibleTicks, rentObjectId, !this.visibleTicks[rentObjectId]);
      }
    },
    isTickVisible(rentObjectId) {
      return this.visibleTicks[rentObjectId] === undefined ? true : this.visibleTicks[rentObjectId];
    }
  }
};
</script>

<style lang="scss" scoped>
.y-axis {
  height: 400px;
  background-color: #f5f5f5;
  border-radius: 8px;
  display: grid;
  grid-template-columns: repeat(12, 8.33%);
  margin-top: 1rem;
  padding-top: 1.5rem;
  overflow: hidden;

  .month {

    position: relative;
    cursor: pointer;
    border-radius: 0.25rem;
    background-color: #f5f5f5;
    text-align: center;

    &:hover {
      background-color: #e5e5e5;
    }

    &.active {
      background-color: #e5e5e5;
    }
  }
}

.x-axis {
  display: grid;
  grid-template-columns: repeat(12, 8.33%);
  margin-top: 1rem;

  .month {
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 0.25rem;
    background-color: #f5f5f5;
    text-align: center;

    &:hover {
      background-color: #e5e5e5;
    }

    &.active {
      background-color: #e5e5e5;
    }
  }
}

.tick {
  transform: translateY(100%);
  bottom: 0;
  height: 12px;
  width: 100%;
  position: absolute;
  box-sizing: border-box;
  opacity: 0.72;

  .percent {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 10px;
    font-weight: 500;
  }
}

.tick-vertical {
  bottom: 0;
  width: 2px;
  position: absolute;
  box-sizing: border-box;
}

.legend {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 1rem;

  .legend-item {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    cursor: pointer;
    transition: opacity 0.3s ease;

    .color {
      width: 1rem;
      height: 1rem;
      border-radius: 0.25rem;
      margin-right: 0.5rem;
    }

    .name {
      font-size: 0.875rem;
    }

    &.legend-item-disabled {
      opacity: 0.5;
    }
  }
}
</style>